var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpiBaja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload-Icono",
    transform: "matrix(1 0 0 -1 0 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9994 1.3L5.19944 11.9364L10.1631 11.9364L10.1631 24.7L15.8358 24.7L15.8358 11.9364L20.7994 11.9364L12.9994 1.3Z",
    id: "Forma",
    fill: "#FC4850",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiBaja);
export default __webpack_public_path__ + "static/media/kpi_baja.a12822c3c8e938c7e1be56425b928314.svg";
export { ForwardRef as ReactComponent };